import { LocalDate } from '../../../utilities/local-date';

export function calendariumMonths(year: string) {
  const months: { name: string; count: number }[] = [];
  let i = 0;
  while (i < 12) {
    const month = LocalDate.fromString(year + '-01-01').plusMonths(i);
    months.push({
      name: month.nameOfMonth(),
      count: month.daysInMonth(),
    });
    i++;
  }
  return months;
}
